import {inject, injectable} from 'inversify';

import type {CourseApiModel} from '../../../../../api/course';
import type {Expand, Expanded, MaybeExpanded} from '../../../../../api/types';
import type {AssessmentMapperJrpc} from '../../../Assessment/mappers/jrpc/Assessment.mapper.jrpc';

import {
  userExpandCommon,
  type UserExpandedCommon,
} from '../../../../../api/user';
import {EnvProviderService} from '../../../../system/env/EnvProvider.service';
import {AssessmentExpandJrpc} from '../../../Assessment/mappers/jrpc/Assessment.expand.jrpc';
import {BaseExpandJrpc} from '../../../Base/mappers/Base.expand.jrpc';

@injectable()
export class BoundAssessmentExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(AssessmentExpandJrpc)
    readonly assessmentExpand: AssessmentExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      bound_form: [
        ['author_id', {name: 'User not found'}, userExpandCommon],
        ['form_id', null, this.assessmentExpand.getByEnv(key)],
        'resource_id',
      ],
    };
    const b2b = base,
      core = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace BoundAssessmentExpandJrpc {
  export type ExpandedFields = {
    author: Expanded<UserExpandedCommon, 'name'>;
    form: MaybeExpanded<AssessmentMapperJrpc.ExpandedApiData>;
    resource: MaybeExpanded<CourseApiModel>;
  };
}
